import { SummaryData } from "src/context/ScoreDetail/ScoreDetailBuilder";
import { ScoreDetailChartBox } from "../../../Chart";
import { ChartMode, ScoreDetailChartData } from "../../../Chart/chart.types";
import { ScoreService } from "src/context/EntityBasedScore/ScoreService";
import { useScoreDetailContext } from "src/context/ScoreDetail/useScoreDetailContext";

type BySummaryProps = {
    summary: SummaryData;
    mode: ChartMode;
};
export const BySummary = (props: BySummaryProps) => {
    const { summary, mode } = props;
    const { scoreList, drilldownState } = useScoreDetailContext();

    const data: ScoreDetailChartData[] = summary.summary.map((item, index) => {
        const scoreItem = ScoreService.normalizeScore(item.score, scoreList.lastSelected.precision);

        // The `index` will be used to find the appropriate summary.detail.XXX
        // .XXX being the category
        // For example, summary.detail.ingredients, or summary.detail.products
        // I am using that index to bend the system of the drilldown.
        const nextItemIndex = index;

        if (index === 0) {
            // This is a workaround.
            // The "main parent element" is supposed to be the first one;
            return {
                title: item.label,
                score: scoreItem,
                action: () => {
                    drilldownState.drilldown({
                        id: nextItemIndex,
                        label: item.label,
                        type: "headings",
                    });
                },
            };
        }

        return {
            title: item.label,
            score: scoreItem,
            action: () => {
                drilldownState.drilldown({
                    id: nextItemIndex,
                    label: item.label,
                    type: "detail",
                });
            },
        };
    });

    const total: ScoreDetailChartData = {
        title: "total",
        score: ScoreService.normalizeScore(summary.totalScore, scoreList.lastSelected.precision),
    };
    return <ScoreDetailChartBox data={data} total={total} mode={mode} />;
};
